<!-- eslint-disable max-len -->
<template>
<svg
    xmlns="http://www.w3.org/2000/svg" width="17" height="17"
    viewBox="0 0 17 17"
    fill="none"
>
    <path d="M0 3.12874L6.96696 2.22517V8.56089H0V3.12874ZM0 14.7216L6.96696 15.6252V9.36803H0V14.7216ZM7.73348 15.7216L17 16.9252V9.36803H7.73348V15.7216ZM7.73348 2.12874V8.56089H17V0.925171L7.73348 2.12874Z" fill="currentColor" />
</svg>
</template>
